import { render } from "./CognitoLogoMark.vue?vue&type=template&id=f9da1274&scoped=true&ts=true"
import script from "./CognitoLogoMark.vue?vue&type=script&lang=ts"
export * from "./CognitoLogoMark.vue?vue&type=script&lang=ts"

import "./CognitoLogoMark.vue?vue&type=style&index=0&id=f9da1274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9da1274"]])

export default __exports__